import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Icon of the TAI (docs/05 §7.5): a target of three circles, drawn with the same stroke as the
 * Lucide set because Lucide has no equivalent. Ready for the TAI card of `f1-asap-and-tai`.
 */
export function TaiIcon({ size = 18, title }) {
    return (_jsxs("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.8, strokeLinecap: "round", strokeLinejoin: "round", role: title ? 'img' : undefined, "aria-hidden": title ? undefined : true, "aria-label": title, children: [_jsx("circle", { cx: "12", cy: "12", r: "9" }), _jsx("circle", { cx: "12", cy: "12", r: "5.5" }), _jsx("circle", { cx: "12", cy: "12", r: "2" })] }));
}
//# sourceMappingURL=TaiIcon.js.map